import { render } from "./ScrollSpyList.vue?vue&type=template&id=34f22508"
import script from "./ScrollSpyList.vue?vue&type=script&lang=js"
export * from "./ScrollSpyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Navigation/ScrollSpyList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34f22508"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34f22508', __exports__)) {
    api.reload('34f22508', __exports__)
  }
  
  module.hot.accept("./ScrollSpyList.vue?vue&type=template&id=34f22508", () => {
    api.rerender('34f22508', render)
  })

}


export default __exports__